module.exports = __webpack_public_path__ + "img/line-graph.312f782d.png";